import React from 'react'
import {
  Badge,
  Button,
  Spinner
} from 'reactstrap'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import PaperPlaneIcon from '../../svgs/PaperPlaneIcon'

const UserRow = ({
  canEdit = false,
  canRemove = false,
  canSendEmail = false,
  currentUserEmail,
  isSendingEmail = false,
  onEdit,
  onRemove,
  onSendEmail,
  user: {
    created_at: createdAt,
    email,
    invitation,
    id,
    role
  }
}) => {
  const { t } = useTranslation(['UsersPage', 'commons'])

  return (
    <tr className={currentUserEmail === email ? 'me' : null}>
      <td>
        {email}
        {invitation && (
          <Badge className="ms-2" color="warning">
            {t('UserRow.badges.invitation')}
          </Badge>
        )}
        {currentUserEmail === email && (
          <Badge className="ms-2" color="primary">
            {t('UserRow.badges.you')}
          </Badge>
        )}
      </td>
      <td>
        {role && (
          <Badge color={role === 'admin' ? 'primary' : 'secondary'}>
            {role}
          </Badge>
        )}
      </td>
      <td>{moment(createdAt).format('LLL')}</td>
      <td>
        <div className="d-flex justify-content-end gap-2">
          <Button
            disabled={!canSendEmail || isSendingEmail}
            name="send-email"
            onClick={() => onSendEmail(id)}
            outline
            title={invitation
              ? t('UserRow.buttons.resendInvitation')
              : t('UserRow.buttons.sendPasswordReset')}
          >
            {isSendingEmail
              ? <Spinner size="sm" />
              : <PaperPlaneIcon />}
          </Button>
          <Button
            disabled={canEdit === false}
            name="edit"
            onClick={() => onEdit(id)}
            outline
          >
            {t('buttons.edit', { ns: 'commons' })}
          </Button>
          <Button
            color="danger"
            disabled={canRemove === false}
            name="remove"
            onClick={() => onRemove(id)}
            outline
          >
            {t('buttons.remove', { ns: 'commons' })}
          </Button>
        </div>
      </td>
    </tr>
  )
}

UserRow.propTypes = {
  canEdit: PropTypes.bool,
  canRemove: PropTypes.bool,
  canSendEmail: PropTypes.bool,
  currentUserEmail: PropTypes.string.isRequired,
  isSendingEmail: PropTypes.bool,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onSendEmail: PropTypes.func.isRequired,
  user: PropTypes.shape({
    created_at: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    invitation: PropTypes.bool.isRequired,
    role: PropTypes.string.isRequired
  }).isRequired
}

export default UserRow
